import styled from "styled-components";

export const PromoPageContainer = styled.div``;
